import { render, staticRenderFns } from "./FanPdfPage.vue?vue&type=template&id=46d726b6&"
import script from "./FanPdfPage.vue?vue&type=script&lang=js&"
export * from "./FanPdfPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports